function SpeakerIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 122.88 84.86"
      className={className}
    >
      <path d="M11.32 19.85h22.57L52.56 1a3.55 3.55 0 015 0 3.48 3.48 0 011 2.51V81.3a3.56 3.56 0 01-6.1 2.49l-18.45-15H11.32A11.35 11.35 0 010 57.49V31.17a11.37 11.37 0 0111.32-11.32zm63.39 11.77A3.32 3.32 0 0181 29.51c1.14 3.39 1.69 8.66 1.6 13.67s-.81 9.72-2.19 12.57a3.33 3.33 0 01-6-2.91c1-2 1.47-5.76 1.55-9.77a38.19 38.19 0 00-1.27-11.45zm17.14-12.4A3.32 3.32 0 0198 16.67c3.08 7.4 4.75 16.71 4.89 26s-1.21 18.25-4.14 25.51a3.31 3.31 0 01-6.15-2.47c2.6-6.44 3.79-14.67 3.67-23s-1.63-16.86-4.41-23.5zm16.57-10.54a3.32 3.32 0 116-2.88 89.44 89.44 0 018.48 37.53c.1 12.58-2.44 25.12-8 35.81a3.31 3.31 0 11-5.89-3c5-9.71 7.32-21.17 7.23-32.72a82.47 82.47 0 00-7.83-34.7z"></path>
    </svg>
  );
}

export default SpeakerIcon;
